<template>
    <register-layout v-on:submit="submit">
        <div class="tw-p-6 tw-space-y-6">
            <div class="tw-text-xl tw-font-bold">{{$word.login_or_register}}:</div>
            <div class="tw-grid tw-gap-6">
                <div>
                    <div class="tw-mb-1 tw-font-bold">{{$word.email_address}}
                        <span class="tw-font-bold tw-text-red-600">*</span>
                    </div>
                    <input type="text" class="form-input" v-model="states.form.email">
                    <div v-html="_.get(errors,'email.0')" class="tw-text-red-500 tw-mt-1"></div>
                </div>


                <div>

                    <div class="tw-mb-1 tw-font-bold">{{$word.password}}
                        <span class="tw-font-bold tw-text-red-600">*</span>
                    </div>
                    <input type="password" class="form-input" v-model="states.form.password">
                    <div v-html="_.get(errors,'password.0')" class="tw-text-red-500 tw-mt-1"></div>
                    <div class="tw-flex tw-items-center tw-flex-wrap tw-space-x-2">
                        <div v-for="(isOk,label) in password_status" :key="label" class="tw-flex tw-items-center" :class="isOk ? 'tw-text-green-600' : 'tw-text-red-500'">
                            <i class="bx tw-text-2xl" :class="isOk ? 'bxs-checkbox-checked' : 'bx-checkbox'"></i>
                            <span>{{label}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </register-layout>
</template>
<script>
    import store from './register-store'
    import RegisterLayout from './register-layout'

    export default {
        components : {RegisterLayout},
        data: v => ({
            states: store.states,
            errors: {},
        }),
        created() {
            this.store = store
        },
        computed : {
          password_status(){
              let password = store.states.form.password;
              return {
                  'Includes lowercase chars' : /[a-z]/.test(password),
                  'Includes uppercase chars' : /[A-Z]/.test(password),
                  'Includes numbers' : /[1-9]/.test(password),
                  // 'Includes special chars like $ % #' : /\!|\@|\#|\$|\%|\^|\&|\*/.test(password),
                  'At least 8 chars' : password.length >=8,
              }
          }
        },
        methods: {
            submit() {
                console.log('submitting')
                store.states.loading = true
                axios.post("/login-or-register", {
                    email: store.states.form.email,
                    password: store.states.form.password,
                }).then(resp => {
                    this.errors = {}

                    if (_.get(resp, 'data.data') === "login") {
                        Vue.$toast.success(resp.data.msg);
                        location.href = `/${window.locale}/dashboard`;
                        return;
                    }

                    if (_.get(resp, 'data.data') === 'register') {
                        store.states.current_step++;
                        return;
                    }

                    Vue.$toast.error(resp.data.msg);
                }).finally(() => {
                    store.states.loading = false
                }).catch(err => {
                    err.response.status === 422 && (this.errors = err.response.data.errors)
                });
            }
        }
    }
</script>
